import {FETCH_ASSETLIST_BEGIN_DDL,
    FETCH_ASSETLIST_SUCCESS_DDL,
    FETCH_ASSETLIST_FAILURE_DDL} from '../constants/assets';

const initialState={
    assetList:[],
    isLoading:false,
    error:""
}


export const getAssetListddlReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_ASSETLIST_BEGIN_DDL: {
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_ASSETLIST_FAILURE_DDL:
        return {
            ...initialState,
            isLoading:false,
            assetList:null
        };
    case FETCH_ASSETLIST_SUCCESS_DDL:
        return {
            ...initialState,
            assetList:payload.assetDataItems,
            isLoading:true,
        };
    default:
        return state;
 }
}

export default getAssetListddlReducer